import { useEffect, useRef } from "react";

export const Cursor = () => {
  const ref = useRef(null);
  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine) and (min-width: 1024px)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const el = ref.current;
    if (!fine || reduced || !el) return;
    el.style.display = "block";
    let x = -100, y = -100, cx = -100, cy = -100, raf;
    const move = (e) => {
      x = e.clientX;
      y = e.clientY;
      const t = e.target;
      const interactive = t.closest && t.closest("a, button, [role='button'], [data-cursor='hover'], label, select");
      el.classList.toggle("is-hover", !!interactive);
      el.classList.toggle("is-dark", !!(t.closest && t.closest("[data-theme='dark']")));
      el.classList.remove("is-hidden");
    };
    const leave = () => el.classList.add("is-hidden");
    const loop = () => {
      cx += (x - cx) * 0.2;
      cy += (y - cy) * 0.2;
      el.style.transform = `translate3d(${cx}px, ${cy}px, 0)`;
      raf = requestAnimationFrame(loop);
    };
    loop();
    window.addEventListener("pointermove", move, { passive: true });
    document.addEventListener("mouseleave", leave);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("pointermove", move);
      document.removeEventListener("mouseleave", leave);
    };
  }, []);
  return <div ref={ref} className="rl-cursor is-hidden" style={{ display: "none" }} aria-hidden="true" data-testid="custom-cursor" />;
};
